/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtEditorComponent } from './ut-editor.component';
import angularjsDependencyProviders from '../../angularjs.providers';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    UtEditorComponent,
  ],
  exports: [
    UtEditorComponent,
  ],
  providers: angularjsDependencyProviders,
})
class UtEditorModule {}

export { UtEditorModule };
